import { render, staticRenderFns } from "./actionIndex.vue?vue&type=template&id=4cab706f&scoped=true"
import script from "./actionIndex.vue?vue&type=script&lang=js"
export * from "./actionIndex.vue?vue&type=script&lang=js"
import style0 from "./actionIndex.vue?vue&type=style&index=0&id=4cab706f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cab706f",
  null
  
)

export default component.exports